import { render, staticRenderFns } from "./FlagDisplay.vue?vue&type=template&id=cc30bf46&scoped=true&"
import script from "./FlagDisplay.vue?vue&type=script&lang=js&"
export * from "./FlagDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FlagDisplay.vue?vue&type=style&index=0&id=cc30bf46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30bf46",
  null
  
)

export default component.exports